import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'
import { jsonToFormData } from '../../../../shared/utils.js'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterOpcoesFiltro(contratoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/opcoes-filtro`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterStatusCriacaoBoletimMedicao(contratoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/status-criacao`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterBoletinsMedicoes(filtro) {
        let url = `${api}/fornecedor/contratos/${
            filtro.contratoId
        }/boletins-medicao/filtro?
                processo=${filtro.processo ? filtro.processo : ''}
                &solicitante=${filtro.solicitante ? filtro.solicitante : ''}
                &dataDe=${filtro.dataInicio ? filtro.dataInicio : ''}
                &dataAte=${filtro.dataFim ? filtro.dataFim : ''}
                &status=${filtro.situacao ? filtro.situacao : ''}`

        return axiosJwt
            .get(url)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterBoletimMedicao(contratoId, boletimMedicaoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterPlanejamentoFisicoFinanceiroPorContrato(contratoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterPlanejamentoFisicoFinanceiro(
        contratoId,
        boletimMedicaoId,
        handleGlobalError = true
    ) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro/boletins-medicao/${boletimMedicaoId}`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                if (error.response && error.response.status === 404) {
                    return { success: false, notFound: true }
                }
                if (handleGlobalError) {
                    return errorHandler(error)
                }
                return { success: false, error: error }
            })
    },

    obterPdfPlanejamentoFisicoFinanceiro(
        contratoId,
        boletimMedicaoId,
        logoBase64
    ) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro/boletins-medicao/${boletimMedicaoId}/comparativo-planejamento/pdf`,
                { logoBase64 },
                {
                    responseType: 'blob'
                }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    gerarPdfItensBoletimMedicao(contratoId, boletimMedicaoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens/pdf`,
                {
                    responseType: 'blob'
                }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    async gerarPdfCurvaS(curvaSRelatorioDto) {
        try {
            const response = await axiosJwt.post(
                `${api}/relatorios/curva-s`,
                curvaSRelatorioDto,
                {
                    responseType: 'blob'
                }
            )
            return response.data
        } catch (error) {
            if (error.response && error.response.data instanceof Blob) {
                const text = await error.response.data.text()
                try {
                    const jsonError = JSON.parse(text)
                    error.response.data = jsonError
                } catch (e) {
                    error.response.data = { message: text }
                }
            }
            throw error
        }
    },

    salvarPlanejamentoFisicoFinanceiro(contratoId, dto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro`,
                dto
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    enviarCronogramaParaAprovacao(contratoId) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro/enviar-para-aprovacao`, {})
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    inserirBoletimMedicao(boletimMedicaoDto) {
        let formData = new FormData()
        formData.append('contratoId', boletimMedicaoDto.contratoId)
        formData.append('competencia', boletimMedicaoDto.competencia)
        formData.append('naoRequerEnvio', boletimMedicaoDto.naoRequerEnvio)
        formData.append('nome', boletimMedicaoDto.nome)
        formData.append(
            'textoComplementar',
            boletimMedicaoDto.textoComplementar
        )
        formData.append(
            'codigoSolicitante',
            boletimMedicaoDto.codigoSolicitante
        )
        formData.append(
            'contatoSolicitante',
            boletimMedicaoDto.contatoSolicitante
        )
        formData.append('dataInicio', boletimMedicaoDto.dataInicio)
        formData.append('dataFim', boletimMedicaoDto.dataFim)
        formData.append('dataNecessidade', boletimMedicaoDto.dataNecessidade)
        formData.append('dataEntrada', boletimMedicaoDto.dataEntrada)

        for (
            let indice = 0;
            indice < boletimMedicaoDto.anexos.length;
            indice++
        ) {
            formData.append(
                `anexos[${indice}].tipo`,
                boletimMedicaoDto.anexos[indice].tipo
            )
            formData.append(
                `anexos[${indice}].arquivo`,
                boletimMedicaoDto.anexos[indice].arquivo
            )
        }

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${boletimMedicaoDto.contratoId}/boletins-medicao`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarBoletimMedicao(boletimMedicaoDto) {
        let formData = new FormData()
        formData.append('boletimMedicaoId', boletimMedicaoDto.boletimMedicaoId)
        formData.append('contratoId', boletimMedicaoDto.contratoId)
        formData.append('competencia', boletimMedicaoDto.competencia)
        formData.append('naoRequerEnvio', boletimMedicaoDto.naoRequerEnvio)
        formData.append('nome', boletimMedicaoDto.nome)
        formData.append(
            'textoComplementar',
            boletimMedicaoDto.textoComplementar
        )
        formData.append(
            'codigoSolicitante',
            boletimMedicaoDto.codigoSolicitante
        )
        formData.append(
            'contatoSolicitante',
            boletimMedicaoDto.contatoSolicitante
        )
        formData.append('dataInicio', boletimMedicaoDto.dataInicio)
        formData.append('dataFim', boletimMedicaoDto.dataFim)
        formData.append('dataNecessidade', boletimMedicaoDto.dataNecessidade)
        formData.append('dataEntrada', boletimMedicaoDto.dataEntrada)

        return axiosJwt
            .put(
                `${api}/fornecedor/contratos/${boletimMedicaoDto.contratoId}/boletins-medicao/${boletimMedicaoDto.boletimMedicaoId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    downloadAnexo(contratoId, boletimMedicaoId, documentoMedicaoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/documentos/${documentoMedicaoId}/download`,
                {
                    responseType: 'blob'
                }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    cancelarBoletimMedicao(contratoId, dto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${dto.boletimMedicaoId}/cancelamento`,
                dto
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    adicionarItemBoletimMedicao(contratoId, dto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${dto.boletimMedicaoId}/itens-medicao`,
                dto
            )
            .then((response) => {
                return response
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarItemBoletimMedicao(contratoId, dto) {
        return axiosJwt
            .put(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${dto.boletimMedicaoId}/itens-medicao/${dto.itemBoletimMedicaoId}`,
                dto
            )
            .then((response) => {
                return response
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    excluirItemBoletimMedicao(
        contratoId,
        boletimMedicaoId,
        itemBoletimMedicaoId
    ) {
        return axiosJwt
            .delete(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens-medicao/${itemBoletimMedicaoId}`
            )
            .then((response) => {
                return response
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    concluirEtapaBoletimMedicao(contratoId, boletimMedicaoId, dto) {
        let formData = new FormData()
        formData.append('boletimMedicaoId', dto.boletimMedicaoId)
        formData.append('contratoId', dto.contratoId)
        formData.append('etapa', dto.etapa)
        if (dto.motivoDevolucao)
            formData.append('motivoDevolucao', dto.motivoDevolucao)
        if (dto.observacao) formData.append('observacao', dto.observacao)
        if (dto.etapaReinicioProcesso)
            formData.append('etapaReinicioProcesso', dto.etapaReinicioProcesso)
        if (dto.numeroProcesso)
            formData.append('numeroProcesso', dto.numeroProcesso)

        for (let indice = 0; indice < dto.anexos.length; indice++) {
            formData.append('anexos', dto.anexos[indice].arquivo)
        }

        if (dto.plantaFaladaEditavel != null)
            formData.append('plantaFaladaEditavel', dto.plantaFaladaEditavel)
        if (dto.declaracaoVinculoEditavel != null)
            formData.append('declaracaoVinculoEditavel', dto.declaracaoVinculoEditavel)
        if (dto.memoriaCalculoEditavel != null)
            formData.append('memoriaCalculoEditavel', dto.memoriaCalculoEditavel)
        if (dto.cronogramaEditavel != null)
            formData.append('cronogramaEditavel', dto.cronogramaEditavel)
        if (dto.curvaSEditavel != null)
            formData.append('curvaSEditavel', dto.curvaSEditavel)
        if (dto.planilhaMedicaoEditavel != null)
            formData.append('planilhaMedicaoEditavel', dto.planilhaMedicaoEditavel)
        if (dto.itensAprovados && dto.itensAprovados.length > 0) {
            for (const id of dto.itensAprovados) {
                formData.append('itensAprovados', id)
            }
        }

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/etapas-concluidas`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    downloadAnexoHistoricoBoletimMedicao(
        contratoId,
        boletimMedicaoId,
        documentoHistoricoBoletimMedicaoId
    ) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/historico/documentos/${documentoHistoricoBoletimMedicaoId}/download`,
                {
                    responseType: 'blob'
                }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterVisualizacaoAbasBoletinsMedicao(contratoId, boletimMedicaoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/visualizacao-abas-boletim-medicao`)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarVisualizacaoFornecedorAbaBoletimMedicao(contratoId, boletimMedicaoId, abaBoletimMedicaoId, visualizada) {
        return axiosJwt
            .patch(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/abas-boletim-medicao/${abaBoletimMedicaoId}`, { visualizada })
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    uploadPlantaFaladaArquivo(contratoId, boletimMedicaoId, uploadDto) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/upload-planta-falada-arquivo`, uploadDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirBoletimMedicao(contratoId, boletimMedicaoId) {
        return axiosJwt
            .delete(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistoricoExclusoesBM(contratoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/historico-exclusoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    deletarPlantaFaladaArquivo(contratoId, boletimMedicaoId) {
        return axiosJwt
            .delete(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/upload-planta-falada-arquivo`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterImagemPlantaFalada(contratoId, boletimMedicaoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/imagem-planta-falada`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    throw error
                }
                return errorHandler(error)
            })
    },

    obterPlantaFaladaAssinada(contratoId, boletimMedicaoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/planta-falada-assinada`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    throw error
                }
                return errorHandler(error)
            })
    },

    exportarPlantaFalada(contratoId, boletimMedicaoId, dto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/exportar-planta-falada`,
                dto,
                {
                    responseType: 'blob'
                }
            )
            .then((response) => {
                return response.data
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    throw error
                }
                return errorHandler(error)
            })
    },

    uploadPlantaFaladaAssinada(contratoId, boletimMedicaoId, uploadDto) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/upload-planta-falada-assinada`, uploadDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    deletarPlantaFaladaAssinada(contratoId, boletimMedicaoId) {
        return axiosJwt
            .delete(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/planta-falada-assinada`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDeclaracaoVinculoPorBoletimMedicao(boletimMedicaoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/declaracao-vinculo/obter-por-boletim/${boletimMedicaoId}`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    incluirProfissionalVinculo(declaracaoId, dto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/declaracao-vinculo/${declaracaoId}/incluir-profissional`,
                dto
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.message ===
                        'Já existe um registro com esse CPF.'
                ) {
                    return {
                        success: false,
                        message: error.response.data.message
                    }
                }
                return errorHandler(error)
            })
    },

    excluirProfissionalVinculo(profissionalId) {
        return axiosJwt
            .delete(
                `${api}/fornecedor/contratos/declaracao-vinculo/excluir-profissional/${profissionalId}`
            )
            .then((response) => {
                return response
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterDeclaracaoVinculoRelatorio(dados) {
        return axiosJwt
            .post(`${api}/relatorios/declaracao-vinculo`, dados, {
                responseType: 'blob'
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    autocompleteProfissional(contratoId, cpf) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${contratoId}/profissionais/autocomplete?cpf=${cpf}`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarProfissionalVinculo(contratoId, profissionalId, dto) {
        return axiosJwt
            .patch(
                `${api}/fornecedor/contratos/${contratoId}/profissionais/${profissionalId}`,
                dto
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                const message =
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                if (
                    message &&
                    (message === 'Já existe um registro com esse CPF.' ||
                        message ===
                            'Já existe um profissional cadastrado com este CPF para este contrato.')
                ) {
                    return { success: false, message: message }
                }
                return errorHandler(error)
            })
    },

    uploadDeclaracaoVinculo(contratoId, boletimMedicaoId, dto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/declaracao-vinculo/upload`,
                dto
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    aprovarItemBoletimMedicaoPeloFiscalTerceiro(contratoId, boletimMedicaoId, itemBoletimMedicaoId) {
        return axiosJwt
            .put(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens/${itemBoletimMedicaoId}/aprovado-fiscal-terceiro`, {})
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovarItemBoletimMedicaoPeloFiscalTerceiro(contratoId, boletimMedicaoId, itemBoletimMedicaoId, dto) {
        return axiosJwt
            .put(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens/${itemBoletimMedicaoId}/reprovado-fiscal-terceiro`, dto)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarItemBoletimMedicaoPeloFiscalObras(contratoId, boletimMedicaoId, itemBoletimMedicaoId) {
        return axiosJwt
            .put(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens/${itemBoletimMedicaoId}/aprovado-fiscal-obras`, {})
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovarItemBoletimMedicaoPeloFiscalObras(contratoId, boletimMedicaoId, itemBoletimMedicaoId, dto) {
        return axiosJwt
            .put(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/itens/${itemBoletimMedicaoId}/reprovado-fiscal-obras`, dto)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    adicionarDocumentoBoletimMedicao(contratoId, boletimMedicaoId, dto) {
        let formData = new FormData();
        formData.append('tipo', dto.tipo);
        formData.append('arquivo', dto.arquivo);

        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/documentos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            });
    },

    excluirDocumentoBoletimMedicao(contratoId, boletimMedicaoId, documentoBoletimMedicaoId) {
        return axiosJwt
            .delete(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/documentos/${documentoBoletimMedicaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            });
    },

    atualizarDocumentoBoletimMedicao(contratoId, boletimMedicaoId, documentoBoletimMedicaoId, dto) {
        let formData = new FormData();
        formData.append('tipo', dto.tipo);
        formData.append('arquivo', dto.arquivo);

        return axiosJwt
            .put(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/documentos/${documentoBoletimMedicaoId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            });
    },
}
